// Extract domain from URL
export function getDomainFromUrl(url: string): string {
  try {
    const urlObj = new URL(url)
    return urlObj.hostname.replace('www.', '')
  } catch (e) {
    return url
  }
}

export function getPlatformVariant(platform: string): 'platform-linkedin' | 'platform-indeed' | 'platform-glassdoor' | 'default' {
  switch (platform) {
    case 'linkedin':
      return 'platform-linkedin'
    case 'indeed':
      return 'platform-indeed'
    case 'glassdoor':
      return 'platform-glassdoor'
    default:
      return 'default'
  }
}

export function getStatusVariant(status: string): 'status-active' | 'status-paused' | 'status-completed' | 'default' {
  switch (status) {
    case 'active':
      return 'status-active'
    case 'paused':
      return 'status-paused'
    case 'completed':
      return 'status-completed'
    default:
      return 'default'
  }
}

export function getStatusDisplay(status: string) {
  switch (status) {
    case 'active':
      return 'Active'
    case 'paused':
      return 'Stopped'
    case 'completed':
      return 'Completed'
    default:
      return status
  }
}
